import BasicLayout from '@/layouts/Basic';

export default [
    {
        path: '/ai',
        name: 'digitalConsole',
        component: BasicLayout,
        children: [
            {
                path: 'ai_digital_console',
                name: 'digitalConsole',
                meta: {
                    title: '数字人_首页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_template',
                name: 'digitalVideoTemplate',
                meta: {
                    title: '数字人_模板列表页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_list',
                name: 'DigicList',
                meta: {
                    title: '数字人_数字人列表页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_task',
                name: 'digitalMy',
                meta: {
                    title: '数字人_任务列表页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_content',
                name: 'DigitalAiContent',
                meta: {
                    title: '数字人_脚本文案',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            }
        ]
    }
];